import React from 'react';
import { SketchPageTitle } from './sketchy';

interface PageWrapperProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  className?: string;
  titleTestId?: string;
}

const PageWrapper: React.FC<PageWrapperProps> = ({ 
  children, 
  title, 
  subtitle, 
  className = '',
  titleTestId,
}) => {
  return (
    <div className={`w-full ${className}`}>
      <div className="mb-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div className="flex-1 min-w-0">
            <SketchPageTitle data-testid={titleTestId}>{title}</SketchPageTitle>
            {subtitle && (
              <p className="mt-2 text-sm text-[var(--color-muted)]">{subtitle}</p>
            )}
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default PageWrapper;
